export default __webpack_public_path__ + "static/media/E5.a67800b6.mp3";